/**
 * Section category metadata — clean typography (no emoji icons),
 * Squarespace-style group ordering, and template badge map.
 *
 * Iter 148 — full visual library rebuild (Phase 1 of 250+ template
 * roadmap). Emoji icons removed per user spec; categories reordered
 * to match Squarespace.
 */

// Empty icon map — categories render with typography only.
// Kept as a const so the picker code stays unchanged.
export const CATEGORY_ICONS = {};

export const GROUP_ORDER = ['Essentials', 'Showcase', 'Engage', 'Premium', 'Top'];

export const TEMPLATE_BADGES = {
  'agency-longscroll':       'FEATURED',
  'agency-glass-stat-hero':  'NEW',
  'agency-service-cards':    'NEW',
  'agency-cta-band':         'NEW',
  'agency-why-grid':         'NEW',
  'agency-stat-quad':        'NEW',
  'agency-review-badge':     'NEW',
  'introduce-hero-fullbleed':  'POPULAR',
  'services-3col':             'POPULAR',
  'pricing-3-tier':            'POPULAR',
  'testimonials-3col':         'POPULAR',
  'contact-split-form':        'POPULAR',
  // New shape templates flagged
  'intro-editorial-magazine':  'NEW',
  'intro-large-typography':    'NEW',
  'intro-floating-card':       'NEW',
  'intro-overlapping':         'NEW',
  'intro-collage':             'NEW',
  'intro-offset-asymmetric':   'NEW',
  'intro-storytelling-bigtype':'NEW',
  'intro-brand-showcase':      'NEW',
  // Iter 189c Phase B — new premium hero variants
  'intro-split-halfcover':     'NEW',
  'intro-testimonial-hero':    'NEW',
  'about-founder-letter':      'NEW',
  'about-values-grid':         'NEW',
  'about-timeline':            'NEW',
  'about-mission-focus':       'NEW',
  'about-statistics':          'NEW',
  // Iter 189c Phase B — new premium About variants
  'about-founder-story-photo': 'NEW',
  'about-collage-values':      'NEW',
  'services-icon-features':    'NEW',
  'services-alternating-rows': 'NEW',
  'services-timeline':         'NEW',
  // Iter 189c Phase B — new premium Services variants
  'services-bento-grid':       'NEW',
  'services-featured-showcase':'NEW',
  // Iter 189c Phase B — new premium Products variants
  'shop-dual-collection':      'NEW',
  'shop-editorial-lookbook':   'NEW',
  // Iter 189c Phase B — new premium Pricing variants
  'pricing-with-testimonial':  'NEW',
  'pricing-annual-toggle':     'NEW',
  // Iter 189c Phase B — new premium Testimonials variants
  't-wall-of-love':            'NEW',
  't-interview-hero':          'NEW',
  // Iter 189c Phase B — new premium Portfolio variants
  'port-case-study-hero':      'NEW',
  'port-client-logos-wall':    'NEW',
  // Iter 189c Phase B — new premium Gallery variants
  'img-masonry-editorial':     'NEW',
  'img-full-bleed-scroll':     'NEW',
};
